/**
 * Make saved phishing markup inert before placing it in an administrator preview.
 *
 * The iframe sandbox remains the primary browser boundary. Removing executable and
 * embedding elements as well prevents stored scripts and nested frames from generating
 * errors or making network requests while an administrator inspects a template. The
 * original HTML is never changed and remains the value saved by the editor.
 */
export function safePreviewHtml(value) {
  const html = String(value ?? '')
  if (!html || typeof DOMParser === 'undefined') return html

  const document = new DOMParser().parseFromString(html, 'text/html')
  document
    .querySelectorAll('script, iframe, frame, object, embed, base, meta[http-equiv]')
    .forEach((node) => node.remove())

  for (const element of document.querySelectorAll('*')) {
    for (const attribute of [...element.attributes]) {
      const name = attribute.name.toLowerCase()
      const compactValue = attribute.value
        .trim()
        .replace(/\s+/g, '')
        .toLowerCase()

      if (name.startsWith('on')) {
        element.removeAttribute(attribute.name)
        continue
      }

      if (
        ['href', 'src', 'action', 'formaction', 'xlink:href'].includes(name) &&
        (compactValue.startsWith('javascript:') ||
          compactValue.startsWith('vbscript:') ||
          compactValue.startsWith('data:text/html'))
      ) {
        element.removeAttribute(attribute.name)
      }
    }
  }

  return `<!doctype html>${document.documentElement.outerHTML}`
}
